import {Injectable} from '@angular/core';
import {HttpApiService} from "./http-api.service";
import {EndpointsService} from "./endpoints.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class NotificationService {

  notificationsCount: number = 0;

  constructor(private api: HttpApiService,
              private endpoints: EndpointsService) {
  }

  getNotifications(): Observable<any> {
    return this.api.get(this.endpoints.getNotificationListUrl(), true);
  }

  getUnReadNotificationsCount(): Observable<any> {
    return this.api.get(this.endpoints.getUnReadNotificationCountUrl(), true);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts